// src/index.js
import React from "react";
import ReactDOM from "react-dom/client"; // Use createRoot from react-dom/client
import "./index.css"; // General global styles
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// Log performance metrics visible
reportWebVitals(console.log);
